import IAPIResponseModel from '../../types/Interface/IAPIResponseModel';
import { PlansResponse } from '../../types/Interface/Plan';
import { ApiEndpoints } from '../Endpoints'; // Import API endpoints
import * as handler from './Handler';

export const retrievePricing = async (): Promise<IAPIResponseModel<PlansResponse[]>> => {
	return await handler.get(ApiEndpoints.Pricing);
};
